import { Link } from 'react-router-dom'

import preservation from '@/assets/images/services/preservation.webp'
import { Button } from '@/components/button'
import { DefaultsEsgIcon } from '@/components/icons/services/defaults-esg'
import { BlockchainIcon } from '@/components/icons/services/preservation/blockchain'
import { ConservationUnitsIcon } from '@/components/icons/services/preservation/conservation-units'
import { FinancialSecuringIcon } from '@/components/icons/services/preservation/financial-securing'
import { SatelliteTechnologyIcon } from '@/components/icons/services/satellite-technology'

import * as Card from '../../components/services-sections/card'
import * as Section from '../../components/services-sections/root'

export function PreservationSection() {
  return (
    <section className="flex flex-col">
      <Section.ContainerRoot>
        <Section.Image src={preservation} />
        <Section.Container>
          <Section.Title>Preservação</Section.Title>
          <Section.Description>
            <Section.DescriptionBold>
              Conectando patrocinadores globais a protetores dos biomas
              brasileiros com monitoramento orbital, rastreabilidade blockchain
              e segurança financeira.
            </Section.DescriptionBold>{' '}
            Cada área preservada é validada por dados satelitais, auditáveis e
            integrados a uma rede de proteção estratégica dos ecossistemas do
            Brasil.
          </Section.Description>
        </Section.Container>
      </Section.ContainerRoot>

      <div className="flex flex-col gap-24">
        <Card.Scroll>
          {/* Card 1 */}
          <Card.Root>
            <Card.Container icon={SatelliteTechnologyIcon}>
              <Card.Description>
                Monitoramento ambiental de alta precisão com{' '}
                <Card.DescriptionBold>
                  tecnologia satelital
                </Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 2 */}
          <Card.Root>
            <Card.Container icon={BlockchainIcon}>
              <Card.Description>
                Transparência total via{' '}
                <Card.DescriptionBold>blockchain</Card.DescriptionBold> em todas
                as transações
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 3 */}
          <Card.Root>
            <Card.Container icon={DefaultsEsgIcon}>
              <Card.Description>
                Conformidade com{' '}
                <Card.DescriptionBold>padrões ESG</Card.DescriptionBold>{' '}
                reconhecidos internacionalmente
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 4 */}
          <Card.Root>
            <Card.Container icon={FinancialSecuringIcon}>
              <Card.Description>
                <Card.DescriptionBold>
                  Segurança financeira
                </Card.DescriptionBold>{' '}
                com custódia em instituições renomadas e lastro em ouro
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 5 */}
          <Card.Root>
            <Card.Container icon={ConservationUnitsIcon}>
              <Card.Description>
                Apoio direto a{' '}
                <Card.DescriptionBold>
                  unidades de conservação
                </Card.DescriptionBold>{' '}
                e áreas protegidas
              </Card.Description>
            </Card.Container>
          </Card.Root>
        </Card.Scroll>

        <Button asChild className="mx-auto max-w-96 uppercase md:w-full">
          <Link to="/preservation">Saiba mais</Link>
        </Button>
      </div>
    </section>
  )
}
